/**
 * Constants from Carbon Destiny (github.com/carbonengine/destiny, MIT).
 * Values must not drift: the conformance suite depends on them.
 */
export const AU = 0.1495978707e12; // meters
export const ORBITAL_PRECESSION = 0.001;
export const WARP_FACTOR_TO_AU_PER_SECOND = 0.001;
export const WARP_FACTOR_TO_ACCELERATION = 1.0 / 1000;
export const WARP_FACTOR_TO_DECELERATION = 1.0 / 3000;
export const MAX_ALIGN_TICKS = 180;
export const TWO_PI = 6.2831853071795862;
export const HALF_PI = 1.57079632679489655;

export enum BallMode {
  GOTO = 0,
  FOLLOW = 1,
  STOP = 2,
  WARP = 3,
  ORBIT = 4,
  MISSILE = 5,
  MUSHROOM = 6,
  BOID = 7,
  TROLL = 8,
  FIELD = 9,
  MINIBALL = 10,
  RIGID = 11,
  FORMATION = 12,
}

/** Modes in which mFollowPtr is live and the ball is registered as a follower. */
export const FOLLOW_MODES: readonly BallMode[] = [
  BallMode.FOLLOW,
  BallMode.ORBIT,
  BallMode.MISSILE,
  BallMode.FORMATION,
];
